import { createSignal, Show } from 'solid-js'
import { authMe, isAdmin, isGuest } from '../store/auth.ts'
import { ManagementDialog } from './management/ManagementDialog.tsx'
import { Button } from './ui/Button.tsx'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuGroupLabel,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from './ui/Dropdown.tsx'

export function UserMenu() {
  const [managementOpen, setManagementOpen] = createSignal(false)

  return (
    <Show when={authMe()?.authEnabled}>
      <ManagementDialog open={managementOpen()} onOpenChange={setManagementOpen} />

      {/* nothing to put in a menu for a guest: they have no account, no settings and
          nothing to log out of. the one thing they might want is to stop being one */}
      <Show when={isGuest()}>
        <Button
          variant="outline"
          size="sm"
          class="h-6 gap-1 px-1.5 text-xs"
          onClick={() => {
            location.href = '/api/auth/login'
          }}
        >
          <div class="i-lucide-log-in size-3.5" />
          log in
        </Button>
      </Show>

      <Show when={!isGuest()}>
        <DropdownMenu>
          <DropdownMenuTrigger as={Button<'button'>} variant="ghost" size="icon" class="size-6 w-6 px-0">
            <div class="i-lucide-user size-4" />
          </DropdownMenuTrigger>
          <DropdownMenuContent class="w-48">
            <DropdownMenuGroup>
              <DropdownMenuGroupLabel class="truncate">
                {authMe()?.displayName ?? 'anonymous'}
                <span class="ml-1 text-xs text-muted-foreground font-normal">{authMe()?.role}</span>
              </DropdownMenuGroupLabel>
            </DropdownMenuGroup>

            <Show when={isAdmin()}>
              <DropdownMenuSeparator />
              <DropdownMenuItem class="items-center gap-2" onSelect={() => setManagementOpen(true)}>
                <div class="i-lucide-users size-4" />
                Users and access
              </DropdownMenuItem>
            </Show>

            <DropdownMenuSeparator />
            <DropdownMenuItem
              variant="destructive"
              class="items-center gap-2"
              onSelect={() => {
                location.href = '/api/auth/logout'
              }}
            >
              <div class="i-lucide-log-out size-4" />
              Log out
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </Show>
    </Show>
  )
}
